<template>
    <div style="margin-left: 7px; margin-right: 7px">
        <div style="font-size: 13px" @click="topClick">

            <van-row>
                <van-col span="18">订单号：{{orderId}}</van-col>
                <van-col span="6" style="color: red;text-align: right">订单详情</van-col>
            </van-row>
            <div>下单时间：{{orderTime}}</div>
            <van-row>
                <van-col span="12">
                    <div>状态：
                        <span v-if="Number(validCode) === -1 || Number(validCode) === 4  || Number(validCode) === 8" style="color: red">{{orderStatus}}</span>
                        <span v-else style="color: limegreen;">{{orderStatus}}</span>
                    </div>
                </van-col>
                <van-col span="12" style="text-align: right">
                    <div v-if="showEstimateFee">预估总佣金：<span style="color: red;">￥{{totalEstimateFee}}</span></div>
                </van-col>
            </van-row>

        </div>
        <div style="margin-top: 8px" @click="bottomClick">
            <van-row>
                <van-col :span="left_span">
                    <Wp_image v-if="skuImg" :url="skuImg"></Wp_image>
                </van-col>
                <van-col :span="right_span" :style="{paddingLeft: right_padding_left, color: '#888888'}">
                    <div class="goods_name_div">{{goodsName}}</div>
                    <!--                <van-row>-->
                    <!--                    <van-col span="12"><div>状态：-->
                    <!--                        <span v-if="Number(validCode) < 15 || Number(validCode) >18" style="color: red">{{orderStatus}}</span>-->
                    <!--                        <span v-else style="color: limegreen;">{{orderStatus}}</span>-->
                    <!--                    </div></van-col>-->
                    <!--                    <van-col span="12" style="text-align: right">数量：x{{totalGoodsNum}}</van-col>-->
                    <!--                </van-row>-->
                    <div>总付款金额：<span style="color: #FF000099;">￥{{totalAmount}}</span></div>
                    <div v-if="showEstimateFee">预估总佣金：<span style="color: #FF000099;">￥{{totalEstimateFee}}</span></div>
                    <div>数量：x{{totalGoodsNum}}</div>

                    <!--                <van-row>-->
                    <!--                    <van-col span="18">完成时间：{{finishTime}}</van-col>-->
                    <!--                    <van-col span="6" style="color: red;text-align: right">详情</van-col>-->
                    <!--                </van-row>-->
                </van-col>
            </van-row>
        </div>

    </div>
</template>

<script>

    import Wp_image from "../../custom/Wp_image";
    export default {
        name: "PddOrderInfoCard_With_Img",
        components: {Wp_image},
        props: {
            orderInfoData: {type: Object, default: null},
        },
        data(){
            return{
                goodsName: '商品名称',
                orderStatus: '订单状态',
                orderId: '订单号',
                totalAmount: 0,
                totalGoodsNum: '商品数量',
                totalEstimateFee: 0,
                orderTime: '',
                finishTime: '',
                validCode: '-1',
                pid: "",
                skuImg: "",
                left_span : 7,
                right_span: 17,
                right_padding_left: "8px",
                // ext1_user: "",
                showEstimateFee: true,
            }
        },
        created(){
            if(this.orderInfoData){
                this.goodsName = this.orderInfoData.goods_name;

                // this.orderStatus = this.orderInfoData.orderStatus;

                this.orderId = this.orderInfoData.order_sn;
                this.totalAmount = this.orderInfoData.order_amount;
                this.totalGoodsNum = this.orderInfoData.goods_quantity;
                this.orderTime = this.$common.retainTimeMinute(this.orderInfoData.order_create_time_s);
                // this.finishTime = this.orderInfoData.tk_earning_time;
                this.validCode = this.orderInfoData.order_status;
                //订单状态： -1 未支付; 0-已支付；1-已成团；2-确认收货；3-审核成功；4-审核失败（不可提现）；5-已经结算；8-非多多进宝商品（无佣金订单）
                switch (this.validCode) {
                    case -1:
                        this.orderStatus = '未支付';
                        break;
                    case 0:
                        this.orderStatus = '已支付';
                        break;
                    case 1:
                        this.orderStatus = '已成团';
                        break;
                    case 2:
                        this.orderStatus = '确认收货';
                        break;
                    case 3:
                        this.orderStatus = '审核成功';
                        break;
                    case 4:
                        this.orderStatus = '审核失败';
                        break;
                    case 5:
                        this.orderStatus = '已经结算';
                        break;
                    case 8:
                        this.orderStatus = '无佣金订单';
                        break;
                    default:
                        this.orderStatus = '---';
                }
                // this.pid = this.orderInfoData.pid;
                this.skuImg = this.orderInfoData.goods_thumbnail_url;

                if(this.skuImg){
                    this.left_span = 7;
                    this.right_span = 17;
                    this.right_padding_left = "8px";
                }else{
                    this.left_span = 0;
                    this.right_span = 24;
                    this.right_padding_left = "0px";
                }

                // let commissionShare = this.orderInfoData.tk_total_rate //* this.$common_pdd.commissionRate_pir;
                this.totalEstimateFee = this.orderInfoData.promotion_amount * this.$common_pdd.commissionRate_pir;
                this.totalEstimateFee = this.totalEstimateFee.toFixed(2);
                // this.showEstimateFee = this.orderInfoData.showEstimateFee;
                this.$log("this.showEstimateFee = " + this.showEstimateFee)
            }
        },

        methods:{
            topClick(){
                this.$emit("topClick");
            },
            bottomClick(){
                this.$emit("bottomClick");
            },
            //
            // /**
            //  * 是否显示佣金数据
            //  */
            // isShowEstimateFee(){
            //     if(this.orderInfoData){
            //         this.ext1_user = this.orderInfoData.ext1_user;
            //         let phone = this.$store.state.userPhone;
            //         if(this.ext1_user && phone && this.ext1_user === phone){
            //             this.$log("3333333")
            //             return false;
            //         }
            //     }
            //     return true;
            // },

        }
    }
</script>

<style scoped>
    .goods_name_div {
        /*!*设置文字超出部分省略号*!*/
        overflow: hidden;
        text-overflow: ellipsis;
        /*white-space: nowrap;*/
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        color: #555555;
        font-size: 15px;
        font-weight: bold;
        margin-bottom: 5px;
    }

</style>